// Components
import { LikesButton, CommentsButton, AppIconWithTooltip, BasicTooltip } from "thrive-components";

// Helpers
import { Truncate } from "@/helpers/Text";

//interfaces
import { IActivityInformationPanel } from "@/interfaces/activityFeed";




const UseActivityInformationPanel = ({appImageUrl = undefined, appName = undefined, className = undefined,time = undefined, dateStamp = undefined, contentTitle = undefined, contentLink = undefined, contentExistsInMultiplePlaces = false, likes = undefined, comments = undefined, recognitionValue = undefined, isReply = false, likesEnabled, commentsEnabled }: IActivityInformationPanel) => {
    const info: JSX.Element[] = [];

    if (appName) {
        info.push(
            <span key="app-icon" className="app-icon"> <AppIconWithTooltip imageUrl={appImageUrl ? `${appImageUrl}?size=thumbnail` : undefined} appName={appName} /></span>
        );
    }

    if (time && dateStamp) {
        info.push(
            <BasicTooltip className='information-panel-tooltip' text={dateStamp}>
                <span key="time" className="time">{time}</span>
            </BasicTooltip>
        );
    }

    if (contentTitle) {
        let title = contentTitle;
        if (contentExistsInMultiplePlaces) {
            title = `${contentTitle} (+ more)`;
        }
        if (contentLink) {
            info.push(
                <a key="contentTitle" className="content-title-link" aria-label="Open content in a new tab" target="_blank" rel="noopener noreferrer" href={contentLink} >
                    {Truncate(title, className === "full-screen-styling" ? 60 : 28)}
                </a>
            );
        } else {
            info.push(
                <span key="contentTitle" className="content-title">
                    {Truncate(title, className === "full-screen-styling" ? 60 : 28)}
                </span>
            );
        }
    }

    if (likesEnabled && likes !== undefined) {
        info.push(
            <span key="likes" className="likes">
                <LikesButton
                    numberOfLikes={likes ?? 0}
                    ariaLabel={`Number of ${likes}`}
                    onButtonClick={() => {}}
                    includeText={true}
                    isActive={false}
                    colour=""
                    isDisabled
                />
            </span>
        );
    }

    if (commentsEnabled && comments !== undefined) {
        info.push(
            <span key="comments" className="comments">
                <CommentsButton
                    numberOfComments={comments ?? 0}
                    ariaLabel={`${comments} comments on content`}
                    onButtonClick={() => {}}
                    includeText={true}
                    isActive={false}
                    isReply={isReply}
                    isDisabled
                />
            </span>
        );
    }

    if (recognitionValue) {
        info.push(
            <span key="recognitionValue" className="recognition-value">
                {Truncate(recognitionValue, className === "full-screen-styling" ? 108 : 28)}
            </span>
        );
    }


    return {info}
};

export default UseActivityInformationPanel;
